import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const INSTALL_COMMAND = "npx remembered-cli";

const copyText = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        const el = document.createElement("textarea");
        el.value = text;
        document.body.appendChild(el);
        el.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(el);
        return ok;
    }
};

export const CopyCommand = ({ command = INSTALL_COMMAND, compact = false, testid = "copy-install-button" }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        const ok = await copyText(command);
        setCopied(true);
        if (ok) toast.success("Copied to clipboard");
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <button
            type="button"
            onClick={handleCopy}
            data-testid={testid}
            className={`group inline-flex items-center gap-2 border border-[#262626] bg-[#0a0a0a] font-mono text-sm text-neutral-200 transition-colors duration-200 hover:border-green-400/60 hover:text-green-400 ${
                compact ? "px-3 py-1.5 text-xs" : "px-5 py-3"
            }`}
        >
            <span className="text-green-400">$</span>
            <span data-testid={`${testid}-command`}>{command}</span>
            {copied ? (
                <Check className="h-4 w-4 text-green-400" data-testid={`${testid}-copied-icon`} />
            ) : (
                <Copy className="h-4 w-4 text-neutral-500 transition-colors group-hover:text-green-400" />
            )}
        </button>
    );
};
